export default __webpack_public_path__ + "static/media/img8.bc9242e8.png";